export default {
  token: (state) => state.auth.auth,
  user: (state) => state.auth.user,
};
